// Service Worker 注册和管理模块

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    // 等待页面加载完成再注册
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // 在 localhost 上也注册，便于开发测试
        checkValidServiceWorker(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          if (process.env.NODE_ENV === 'development') {
            console.log(
              '此应用正在通过 Service Worker 提供离线优先服务。'
            );
          }
        });
      } else {
        // 生产环境正常注册
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      if (process.env.NODE_ENV === 'development') {
        console.log('[SW] Service Worker 注册成功');
      }

      // 检查更新
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // 新的 Service Worker 已安装，但旧的仍在控制页面
              if (process.env.NODE_ENV === 'development') {
                console.log('[SW] 新版本可用，准备更新...');
              }

              // 通知用户有新版本
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // 自动激活新的 Service Worker
              installingWorker.postMessage({ type: 'SKIP_WAITING' });

              // 提示用户刷新
              if (config && config.onUpdate) {
                // 延迟一小段时间后刷新，确保 SW 已激活
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            } else {
              // 首次安装
              if (process.env.NODE_ENV === 'development') {
                console.log('[SW] 内容已缓存，可离线使用');
              }

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // 定期检查更新（每小时检查一次）
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60);
    })
    .catch((error) => {
      console.error('[SW] Service Worker 注册失败:', error);
    });

  // 监听 Service Worker 控制权变化
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    if (process.env.NODE_ENV === 'development') {
      console.log('[SW] 控制权已转移到新的 Service Worker');
    }
  });
}

function checkValidServiceWorker(swUrl, config) {
  // 检查 Service Worker 是否存在
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Service Worker 不存在，重新加载页面
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service Worker 存在，正常注册
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      if (process.env.NODE_ENV === 'development') {
        console.log('[SW] 无网络连接，应用运行在离线模式');
      }
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// 检查是否有新版本
export function checkForUpdates() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.update();
    });
  }
}

